module.exports = __webpack_public_path__ + "7dc889a3849b6ba4b09a046284a40c1b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-left-27.png
// module id = 3187
// module chunks = 0